import React from "react"

import { Container, Typography } from "@material-ui/core"
import Layout from "../components/Layout"

import Hero from "./../components/Hero"

import { graphql, Link } from "gatsby"

const NewsRoomCards = ({ blogs }) => {
  //   return <div>{JSON.stringify(blogs)}</div>
  return (
    <div>
      <ul className="blog-list">
        {[...blogs].map(blog => {
          const blogText = blog.html.replace(/<[^>]+>/g, "")
          return (
            <Link to={blog.frontmatter.path} className="cloud">
              <div className="text">
                <img
                  className="blog-hero-image"
                  src={blog.frontmatter.hero_image?.publicURL}
                />
                <div className="blog-card-content">
                  <Typography variant="body1" component="h1">
                    {blog.frontmatter.title}
                  </Typography>
                  <Typography variant="caption" className="author">
                    By {blog.frontmatter.author}
                  </Typography>
                </div>
              </div>
            </Link>
          )
        })}
      </ul>
    </div>
  )
}

function NewsRoom({ data }) {
  console.log(data)
  return (
    <Layout
      cssClass="newsroom-page"
      title="INVIZ AI Solutions | Blogs"
      description="We are a global software and intelligence consultancy company focused on building software, cloud and data solutions with intelligence."
    >
      <Hero>
        <h1>
          <strong>
            <span className="">Newsroom</span>
          </strong>
        </h1>
      </Hero>
      <section>
        <NewsRoomCards
          blogs={data.allMarkdownRemark.edges.map(edge => edge.node)}
        />
      </section>
    </Layout>
  )
}

export default NewsRoom

export const query = graphql`
  query AllNewsArticles {
    allMarkdownRemark(filter: { fileAbsolutePath: { regex: "/newsroom/" } }) {
      edges {
        node {
          frontmatter {
            date
            title
            author
            path
            hero_image {
              publicURL
            }
          }
          html
        }
      }
    }
  }
`
